import React, { useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import InnerHeading from "../../Global Functions/innerHeading";
import { ReactComponent as Cab } from "../../Global Icons/Cab.svg"; // Replace with relevant icon
import { useNavigate } from "react-router-dom";
import TextInput from "../../Global Functions/textInput";
import SelectInput from "../../Global Functions/selectInput";
import { useDispatch, useSelector } from "react-redux";
import {
  viewCountryListPagination,
  viewStateListPagination,
  viewCityList,
} from "../../Redux/Actions/settingsActions";
import { ScrollTop } from "../../Utils/helpers";
import { addReferralCommission } from "../../Redux/Actions/referralCommissionAction";
import toast from "react-hot-toast";
import TwoButtons from "../../Global Functions/buttons";

const AddReferralCommission = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { countryList } = useSelector((state) => state.country || {});
  const { states } = useSelector((state) => state.states || {});
  const { cities } = useSelector((state) => state.city || {});
  const { user } = useSelector((state) => state.auth || {});

  const [referralState, setReferralState] = useState({
    country: "",
    state: "",
    city: "",
    unit: "",
    _unit_: "",
    referral_amount: "",
    status: "active", // default active
  });

  const navigateToList = () => {
    navigate("/referral_commission");
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "unit") {
      setReferralState((prevData) => ({
        ...prevData,
        unit: value,
        _unit_: value.replace(/\s+/g, ""),
      }));
    } else {
      setReferralState((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  useEffect(() => {
    ScrollTop();
    dispatch(viewCountryListPagination());
  }, [dispatch]);

  useEffect(() => {
    if (referralState.country) {
      dispatch(viewStateListPagination({ country: referralState.country }));
      setReferralState((prev) => ({ ...prev, state: "", city: "" }));
    }
  }, [referralState.country, dispatch]);

  useEffect(() => {
    if (referralState.state) {
      dispatch(viewCityList({ state: referralState.state, page: 1, limit: 100 }));
      setReferralState((prev) => ({ ...prev, city: "" }));
    }
  }, [referralState.state, dispatch]);

  const handleSubmit = async () => {
    try {
      if (
        !referralState.country ||
        !referralState.state ||
        !referralState.city ||
        !referralState.unit ||
        !referralState.referral_amount
      ) {
        return toast.error("Please fill all required fields.");
      }

      const payload = {
        country: referralState.country,
        state: referralState.state,
        city: referralState.city,
        unit: referralState.unit,
        _unit_: referralState._unit_,
        referral_amount: Number(referralState.referral_amount),
        status: "active", // forced active status
        created_by: user?.id || user?._id || "defaultAdminId"
 // Replace with dynamic user if available
      };

      const response = await dispatch(addReferralCommission(payload));
      if (response.statusCode === 200) {
        toast.success("Referral commission added successfully");
        navigateToList();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Submit failed");
    }
  };

  return (
    <MainLayout>
      <div className="bg-white grid-span-5 radius-20 padding-20 grid-template-2 gap-10 full-screen full-height">
        <InnerHeading
          Icon={Cab}
          heading="Add Referral Commission"
          buttonLabel="View Referral Commissions"
          onClick={navigateToList}
        />
        <SelectInput
          label="Select Country"
          placeholder="Select Country"
          value={referralState.country}
          name="country"
          onChange={handleChange}
          required
          options={
            Array.isArray(countryList?.data)
              ? countryList.data.map((c) => ({ label: c.country_name, value: c._id }))
              : []
          }
        />
        <SelectInput
          label="Select State"
          placeholder="Select State"
          value={referralState.state}
          name="state"
          onChange={handleChange}
          required
          disabled={!referralState.country}
          options={
            Array.isArray(states?.data)
              ? states.data.map((s) => ({ label: s.state_name, value: s._id }))
              : []
          }
        />
        <SelectInput
          label="Select City"
          placeholder="Select City"
          value={referralState.city}
          name="city"
          onChange={handleChange}
          required
          disabled={!referralState.state}
          options={
            Array.isArray(cities?.data)
              ? cities.data.map((c) => ({ label: c.city_name, value: c._id }))
              : []
          }
        />
        <TextInput
          label="Unit"
          name="unit"
          value={referralState.unit}
          onChange={handleChange}
          required
        />
        {/* Unit Short Code input hidden - removed from form */}
        <TextInput
          label="Referral Amount"
          name="referral_amount"
          type="number"
          value={referralState.referral_amount}
          onChange={handleChange}
          required
        />
        {/* Status input removed */}
        <div className="span2">
          <TwoButtons
            buttonHead1="Cancel"
            noUrl={true}
            LinkURL="/referral_commission"
            onClick2={handleSubmit}
            buttonHead2="Save"
          />
        </div>
      </div>
    </MainLayout>
  );
};

export default AddReferralCommission;
